import { render, staticRenderFns } from "./NuevoAvisoModal.vue?vue&type=template&id=402d1a0c&scoped=true"
import script from "./NuevoAvisoModal.vue?vue&type=script&lang=js"
export * from "./NuevoAvisoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402d1a0c",
  null
  
)

export default component.exports